import { render, staticRenderFns } from "./ViewDeliveryNote.vue?vue&type=template&id=9b402562&scoped=true&"
import script from "./ViewDeliveryNote.vue?vue&type=script&lang=js&"
export * from "./ViewDeliveryNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b402562",
  null
  
)

export default component.exports